/* eslint-disable no-prototype-builtins */
import store from '@root/src/javascripts/store'
import { inRange } from 'lodash'
import { looksLikeAnInteger } from '@lib/validations'

export const transformTariffOptionsForAPI = () => {
  let tariffOptions = []

  Object.keys(store.state.newContract.tariffOptions).forEach((elementalKey) => {
    const tariffOption = store.state.newContract.tariffOptions[elementalKey]
    const elemental = {
      key: elementalKey,
      attributes: [],
    }

    Object.keys(tariffOption).forEach((attributeKey) => {
      const value = tariffOption[attributeKey]
      if (attributeKey === 'selected') {
        elemental.selected = value
      } else {
        elemental.attributes.push({
          key: attributeKey,
          value: `${value}`,
        })
      }
    })
    if (elemental.key === 'surcharges') {
      const paymentFrequencyAttribute = elemental.attributes.find((attribute) => attribute.key === 'payment_frequency')
      if (paymentFrequencyAttribute) {
        paymentFrequencyAttribute.value = store.state.newContract.insurance.paymentInterval
      } else {
        elemental.attributes.push({
          key: 'payment_frequency',
          value: store.state.newContract.insurance.paymentInterval,
        })
      }
    }
    tariffOptions.push(elemental)
  })

  tariffOptions = tariffOptions.map((tariffOption) => {
    // FIXME: https://jira.sumcumo.net/browse/DEXMFV-1229
    if (tariffOption.key === 'partially_comprehensive') {
      const parkDamageAttributes = tariffOption.attributes.filter((attribute) => ['park_damage', 'park_damage_deductible'].includes(attribute.key))
      if (parkDamageAttributes.length === 0) {
        tariffOption.attributes.push({
          key: 'park_damage',
          value: '',
        }, {
          key: 'park_damage_deductible',
          value: '0',
        })
      }
    }
    if (tariffOption.key === 'gross_negligence') {
      tariffOption.attributes[0].value = tariffOption.attributes[0].value === 'true' ? '1' : '0' // eslint-disable-line no-param-reassign
    }
    return tariffOption
  })

  return tariffOptions
}

function getVehicleUses(vehicleUsage) {
  const vehicleUses = new Set()
  if (vehicleUsage.business) {
    vehicleUses.add('private')
    vehicleUses.add('way_to_work')
    vehicleUses.add('commercial')
  }
  if (vehicleUsage.transport) {
    vehicleUses.add('private')
    vehicleUses.add('way_to_work')
    vehicleUses.add('commercial_third_party_invoice')
  }
  if (vehicleUsage.private) {
    vehicleUses.add('private')
  }
  if (vehicleUsage.way_to_work) {
    vehicleUses.add('way_to_work')
  }
  if (vehicleUses.size === 0) {
    vehicleUses.add('private')
    vehicleUses.add('way_to_work')
  }
  return Array.from(vehicleUses)
}

export const transformVehicleDataForAPI = () => {
  const { vehicle, vehicleUsage } = store.state.newContract
  const filteredKeys = store.state.newContract.searchmode === 'typenumber'
    ? [
      'typeCertificateNumber',
      'ownedSince',
      'leasing',
      'initialRegistrationYear',
      'id',
      'canton',
    ] : [
      'ownedSince',
      'model',
      'leasing',
      'initialRegistrationYear',
      'id',
      'canton',
      'brand',
    ]

  const vehicleObj = filteredKeys.reduce((obj, key) => ({ ...obj, [key]: vehicle[key] }), {})
  if (store.state.newContract.searchmode !== 'typenumber') {
    vehicleObj.fuelTypeId = store.state.newContract.vehicle.fuel.id
  }
  if (vehicle.vehicleType === '02') {
    vehicleObj.truckExtEquipmentPrice = vehicle.truckExtEquipmentPrice
    vehicleObj.truckIntEquipmentPrice = vehicle.truckIntEquipmentPrice
  }
  vehicleObj.vehicleUses = getVehicleUses(vehicleUsage)

  return vehicleObj
}

export const transformInsuranceDataForAPI = () => {
  let apiInsuranceData = ''
  let agent = null
  let documentDispatch = null
  const {
    avbPdfUrl, // eslint-disable-line no-unused-vars, camelcase
    pibPdfUrl, // eslint-disable-line no-unused-vars, camelcase
    vehicleRegistrationType,
    paymentInterval, // eslint-disable-line no-unused-vars
    paymentType, // eslint-disable-line no-unused-vars
    ...insurance
  } = store.state.newContract.insurance

  if (store.state.agent.isAgent) {
    agent = { id: store.state.agent.details.id, token: store.state.agent.token }
    // this seperation has to be done to prevent that the insurance
    // uses ___typename from the store part of documentDispatch
    documentDispatch = {
      agentEmail: store.state.newContract.insurance.documentDispatch.agentEmail,
      customerDocuments: store.state.newContract.insurance.documentDispatch.customerDocuments,
      invoices: (store.state.newContract.insurance.paymentInterval !== 'yearly') ? store.state.newContract.insurance.documentDispatch.invoices : ['customer'],
      emails: store.state.newContract.insurance.documentDispatch.emails,
      reminders: store.state.newContract.insurance.documentDispatch.reminders,
    }
  } else if (store.state.agent.details.id) {
    agent = { id: store.state.agent.details.id }
  }
  apiInsuranceData = { ...insurance, agent, documentDispatch }

  if (vehicleRegistrationType) {
    apiInsuranceData.vehicleRegistrationType = vehicleRegistrationType
  }

  return apiInsuranceData
}

export const transformFunnelPriceInfoDataForAPI = () => {
  const mapPrice = (price) => {
    if (price) {
      return { chf: price.chf, rappen: price.rappen, raw: price.raw }
    }
    return null
  }
  const funnelPriceInfo = {
    displayedPrice: mapPrice(store.state.newContract.productPrice.price),
    displayedPremiumKm: mapPrice(store.state.newContract.productPrice.premiumKm),
    displayedCumulatedFixPremium:
      mapPrice(store.state.newContract.productPrice.cumulatedFixPremium),
    displayedCapPremium: mapPrice(store.state.newContract.productPrice.capPremium),
    quoteId: store.state.newContract.productPrice.quoteId,
  }
  return funnelPriceInfo
}

const hasDeductibleLiability = (tariffLiability) => {
  if (tariffLiability.hasOwnProperty('deductible')) {
    const { deductible } = tariffLiability
    if (!(looksLikeAnInteger(deductible)
          && inRange(~~deductible, 0, 10001))) {
      return true
    }
  }
  return false
}

const shouldSkipPartiallyComprehensiveDecuctible = (partiallyComprehensive) => {
  if (partiallyComprehensive.hasOwnProperty('deductible')) {
    const { deductible } = partiallyComprehensive
    if (!(looksLikeAnInteger(deductible)
          && inRange(~~deductible, 0, 5001))) {
      return true
    }
  }

  if (partiallyComprehensive.hasOwnProperty('park_damage_deductible')) {
    const parkDamageDeductible = partiallyComprehensive.park_damage_deductible
    if (!(looksLikeAnInteger(parkDamageDeductible)
          && inRange(~~parkDamageDeductible, 0, 1001))) {
      return true
    }
  }
  return false
}

const shouldSkipFullyComprehensiveDecuctible = (fullyComprehensive) => {
  if (fullyComprehensive.hasOwnProperty('deductible')) {
    const { deductible } = fullyComprehensive
    if (!(looksLikeAnInteger(deductible)
          && inRange(~~deductible, 0, 10001))) {
      return true
    }
  }
  return false
}

const hasInvalidVehicleDataInput = (vehicle) => {
  if (
    Number.isNaN(vehicle.initialRegistrationYear)
    || !(typeof vehicle.typeCertificateNumber === 'string')
    || vehicle.typeCertificateNumber.length < 6
  ) {
    return true
  }
  if (
    !vehicle.initialRegistrationYear
    || !vehicle.brand
    || !vehicle.model
  ) {
    return true
  }
  return false
}

const hasInvalidZip = (zip) => zip.length < 4 || Number.isNaN(zip)

export const skipProductPrice = () => {
  const { tariffOptions, personal, vehicle } = store.state.newContract
  const twentyFourHourAss = tariffOptions && tariffOptions['24_assistance'] ? tariffOptions['24_assistance'] : {}

  if (!tariffOptions) {
    return true
  }

  if (tariffOptions.liability) {
    if (hasDeductibleLiability(tariffOptions.liability)) {
      return true
    }
  }

  if (tariffOptions.partially_comprehensive) {
    if (shouldSkipPartiallyComprehensiveDecuctible(tariffOptions.partially_comprehensive)) {
      return true
    }
  }

  if (tariffOptions.fully_comprehensive) {
    if (shouldSkipFullyComprehensiveDecuctible(tariffOptions.fully_comprehensive)) {
      return true
    }
  }

  if (twentyFourHourAss.selected && twentyFourHourAss.bundle === '') {
    return true
  }

  if (store.state.newContract.searchmode === 'typenumber') {
    if (hasInvalidVehicleDataInput(vehicle)) {
      return true
    }
  }

  if (hasInvalidZip(personal.zip)) {
    return true
  }

  return false
}

export const transformPersonalDataForAPI = () => {
  /* eslint-disable no-unused-vars */
  const { personal, customerType } = store.state.newContract
  if (customerType === 'company') {
    const {
      firstName,
      lastName,
      age,
      dateOfBirth,
      driverLicenceSinceYear,
      ...personalDataObj
    } = personal
    return personalDataObj
  }
  const {
    company,
    industry,
    uid,
    ...personalDataObj
  } = personal
  return personalDataObj
}

export const transformPersonalDataForPriceRequest = () => {
  // removes fields that are not needed for price request from personal data
  const {
    firstName,
    lastName,
    street,
    houseNumber,
    email,
    phone,
    ...personalDataObj
  } = transformPersonalDataForAPI()

  return personalDataObj
}

export const transformFastQuoteDataForAPI = () => {
  const { newContract } = store.state
  const fastQuoteData = {
    vehicleRegistrationType: newContract.insurance.vehicleRegistrationType,
    nationality: newContract.personal.nationality,
    zip: newContract.personal.zip,
    initialRegistrationYear: newContract.vehicle.initialRegistrationYear,
    billingModel: newContract.insurance.billingModel,
    whitelabelPartnerKey: newContract.whitelabelPartnerKey,
  }
  if (newContract.customerType === 'person') {
    fastQuoteData.age = newContract.personal.age
  } else {
    fastQuoteData.gender = newContract.personal.gender
  }
  fastQuoteData.brand = newContract.vehicle.brand
  fastQuoteData.model = newContract.vehicle.model
  if (newContract.searchmode === 'typenumber') {
    fastQuoteData.typeCertificateNumber = newContract.vehicle.typeCertificateNumber
  } else {
    if (newContract.vehicle.fuel.id) {
      fastQuoteData.fuelTypeId = newContract.vehicle.fuel.id
    }

    if (newContract.vehicle.power.range) {
      fastQuoteData.powerHpFrom = ~~newContract.vehicle.power.range.split(':')[0]
      fastQuoteData.powerHpTo = ~~newContract.vehicle.power.range.split(':')[1]
    }
  }

  return fastQuoteData
}

export const productPriceVariables = () => {
  const variables = {
    insurance: transformInsuranceDataForAPI(),
    personal: transformPersonalDataForPriceRequest(),
    vehicle: transformVehicleDataForAPI(),
    tariffOptions: transformTariffOptionsForAPI(),
    whitelabelPartnerKey: store.state.newContract.whitelabelPartnerKey,
  }

  if (store.state.newContract.vehicle.power.range) {
    variables.vehicle.powerHpFrom = ~~store.state.newContract.vehicle.power.range.split(':')[0]
    variables.vehicle.powerHpTo = ~~store.state.newContract.vehicle.power.range.split(':')[1]
  }

  return variables
}
